// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const mr: ChromeTranslations = {
  'nav.nextPage': 'पुढील पान →',
  'nav.previousPage': '← मागील पान',
  'nav.continueToLevel': 'पातळीकडे जा →',
  'nav.backToMenu': 'मेनूकडे परत →',
  'howto.page': '{total} पैकी पान {n}',
  'options.title': 'पर्याय',
  'ui.language': 'भाषा',
};
